export const environment = {
  production: true,
  key: 'bTBqMXhJbmMhMTIzNDU2'
};
